<template>
    <select-input
        :items="Gender.options"
        v-bind="$attrs"
    >
        <template #active="{ bindings }">
            <flex-container
                v-if="bindings.value"
                align-items="center"
                gap="sm"
                size="auto"
                inline
            >
                <svg-icon :icon="getIcon(bindings.value.value)" is-custom-icon /> {{ bindings.value.label }}
            </flex-container>
            <span v-else>
                Maak een keuze
            </span>
        </template>
        <template #item="{ bindings }">
            <flex-container
                align-items="center"
                gap="sm"
                size="auto"
                inline
            >
                <svg-icon :icon="getIcon(bindings.item.value)" is-custom-icon /> {{ bindings.item.label }}
            </flex-container>
        </template>
    </select-input>
</template>

<script lang="ts" setup>
    import { SelectInput } from '@keyvue/one-ui';
    import IconMale from '@keyvue/one-awesome-icons/icons/regular/mars.svg?component';
    import IconFemale from '@keyvue/one-awesome-icons/icons/regular/venus.svg?component';
    import IconAgender from '@keyvue/one-awesome-icons/icons/regular/genderless.svg?component';
    import { Gender } from '@keyvue/one-api-client';

    function getIcon(gender: string): any {
        const iconMap: { [key: string]: any } = {
            [Gender.FEMALE.value]: IconFemale,
            [Gender.MALE.value]: IconMale,
            [Gender.NEUTRAL.value]: IconAgender,
        };

        return iconMap[gender];
    }
</script>
